<template>
  <card class="flex flex-col gap-6 h-fit w-full" padding="p-6">
    <div class="flex flex-row gap-2 items-baseline justify-between">
      <div class="flex flex-col gap-1">
        <span class="font-bold text-lg">
          {{ procedure.source_procedure.name }}
        </span>
        <div class="flex flex-row gap-2">
          <badge v-for="situation in procedure.situations" :key="situation.id" class="bg-sky-400">
            {{ situation.sourceProcedureSituation.source_situation.description }}
          </badge>
        </div>
      </div>

      <div class="flex flex-row gap-4">
        <!-- Lápis só aparece se tiver edit = true + permissão global -->
        <rpm-button
            v-if="procedure.executed_at && procedure.in_progress && canEdit"
            @click="editModalOpen = true"
            no-border
            icon="fa-solid fa-pen-to-square"
            color="theme"
            class="rounded-full h-8 w-8"
            font-class="text-lg"
        ></rpm-button>

        <rpm-button
            @click="printProcedure"
            no-border
            icon="fa-solid fa-print"
            class="rounded-full h-8 w-8"
            font-class="text-lg"
            color="theme"
            v-if="procedure.executed_at"
        ></rpm-button>
      </div>
    </div>

    <!-- Se já foi executado, mostra o caso executado -->
    <ExecutedCase
        v-if="procedure.executed_at"
        :procedure="procedure"
        @deleted="$emit('deleted', $event)"
        @confirm="confirm"
    />

    <!-- Se NÃO foi executado, só mostra o formulário se execute = true -->
    <NotExecutedCase
        v-else-if="canExecute"
        :procedure="procedure"
        @procedure-executed="procedureExecuted"
    />

    <edit-procedure-execution
        :procedure="procedure"
        :open="editModalOpen"
        @close="editModalOpen = false"
        @edited="$emit('edited'); editModalOpen = false"
    ></edit-procedure-execution>
  </card>
</template>

<script>
import ExecutedCase from "./executedCase.vue";
import NotExecutedCase from "./notExecutedCase.vue";
import RpmSpinner from "#components/RpmSpinner.vue";
import Badge from "#components/Badge.vue";
import questionnaireAnswersRepository from "#repositories/questionnaireAnswersRepository.js";
import procedureRepository from "#repositories/procedureRepository.js";

import EditProcedureExecution from "./edit/edit.vue";

export default {
  name: "Executor",
  components: {
    Badge,
    RpmSpinner,
    ExecutedCase,
    NotExecutedCase,
    EditProcedureExecution,
  },
  props: {
    procedure: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      executed: false,
      editModalOpen: false,
    };
  },
  computed: {
    procedureActions() {
      if (!this.procedure) return {};
      // principal: actions dentro de source_procedure
      if (this.procedure.source_procedure && this.procedure.source_procedure.actions) {
        return this.procedure.source_procedure.actions;
      }
      // fallback se em algum cenário vier direto
      if (this.procedure.actions) return this.procedure.actions;
      return {};
    },
    canExecute() {
      return !!this.procedureActions.execute && this.$can("services.procedure.execute");
    },
    canEdit() {
      return !!this.procedureActions.edit && this.$can("services.procedure.edit");
    },
  },
  methods: {
    procedureExecuted(event) {
      this.procedure.executed_at = event.executed_at;
      this.$emit("procedureExecuted");
    },
    async confirm(event) {
      await questionnaireAnswersRepository.updateAnswer(this.procedure.id, event);
      this.$notify("Questão modificada");
      this.$emit("questionnaireChange");
    },
    printProcedure() {
      procedureRepository
          .printProcedure(this.procedure.service, this.procedure.id)
          .then((response) => {
            let headers = response.headers;
            let blob = new Blob([response.data], {
              type: "application/pdf",
            });
            let link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = headers["content-disposition"].split("filename=")[1];
            link.target = "_blank";
            link.click();
            link.remove();
          });
    },
  },
};
</script>
